export enum NameMonth {
	Janvier = "Janvier",
	Fevrier = "Février",
	Mars = "Mars",
	Avril = "Avril",
	Mai = "Mai",
	Juin = "Juin",
	Juillet = "Juillet",
	Aout = "Août",
	Septembre = "Septembre",
	Octobre = "Octobre",
	Novembre = "Novembre",
	Decembre = "Décembre"
}



// WEBPACK FOOTER //
// ./src/shared/models/name-month.ts